<table class="packet-table">
  <tfoot>
    <tr>
      <th>총 횟수</th>
      <th>출석</th>
      <th>남은횟수</th>
      <th *ngIf="hasAddition()">추가횟수</th>
    </tr>
  </tfoot>
  <tbody>
    <tr>
      <td>{{total}}</td>
      <td>{{attend}}</td>
      <td>{{remain}}</td>
      <td class="blur" *ngIf="hasAddition()">{{addition}}</td>
    </tr>
  </tbody>
</table>
